
import Vue from "vue";
import store from "@/store";
import { convertFullDate } from "@/utils/date";
import AppWarning from "@/components/UI/AppWarning.vue";
import AppLoading from "@/components/UI/AppLoading.vue";
import { convertToPersian, separateDigits } from "@/utils/string";
export default Vue.extend({
  name: "InvoicesList",

  components: { AppLoading, AppWarning },

  data() {
    return {
      dialog: false,

      tableHeaders: [
        "ردیف",
        "آدرس",
        "مجموع قیمت فاکتور",
        "وضعیت",
        "تاریخ",
        "وضعیت نهایی",
        "محصولات",
      ],
    };
  },

  computed: {
    invoicesList() {
      return store.state.admin.invoicesList;
    },
  },

  methods: {
    checkStatus(status: number) {
      if (status === 0) {
        return "در انتظار تایید";
      } else if (status === 1) {
        return "در حال ارسال";
      } else if (status === 2) {
        return "انجام شده";
      }
    },
    editInvoice(status: number, id: string) {
      if (status === 0) {
        store.dispatch("admin/acceptInvoice", id);
      } else {
        store.dispatch("admin/endInvoice", id);
      }
    },
    convertFullDate,
    separateDigits,
    convertToPersian,
  },

  created(): void {
    if (!store.state.admin.invoicesList.length) {
      store.state.app.pageLoading = true;
      store.dispatch("admin/getInvoicesList");
    }
  },
});
